import React, { memo } from 'react';
import { Flex } from 'pcln-design-system';
import ChildAgeSelect from '../ChildAgeSelect';
import TravelerLineItem from '../TravelerLineItem';
import Divider from '../Divider';
var ChildrenLineItem = function (_a) {
  var ages = _a.ages,
    ageSelectEnabled = _a.ageSelectEnabled,
    className = _a.className,
    count = _a.count,
    max = _a.max,
    isHotel = _a.isHotel,
    onAgeChange = _a.onAgeChange,
    onChange = _a.onChange,
    subLabel = _a.subLabel;
  var selects = Array(count).fill(0);
  return React.createElement(Flex, {
    flexDirection: 'column',
    width: 1
  }, React.createElement(TravelerLineItem, {
    className: className,
    label: 'Children',
    subLabel: !ageSelectEnabled && subLabel,
    min: 0,
    max: max,
    count: count,
    onChange: onChange
  }), ageSelectEnabled && selects.map(function (value, index) {
    return React.createElement(React.Fragment, {
      key: "container-".concat(index)
    }, React.createElement(ChildAgeSelect, {
      key: index,
      index: index,
      isHotel: isHotel,
      value: ages && ages[index],
      onChange: onAgeChange
    }), index !== selects.length - 1 && React.createElement(Divider, null));
  }));
};
export default memo(ChildrenLineItem);